import React, { useRef, useState } from "react";

export default function BeforeAfterSlider({ image }) {
  const containerRef = useRef(null);
  const [pos, setPos] = useState(50);
  const dragging = useRef(false);

  const onMove = (clientX) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = Math.max(0, Math.min(clientX - rect.left, rect.width));
    setPos((x / rect.width) * 100);
  };

  return (
    <div
      ref={containerRef}
      className="relative w-full aspect-[16/9] rounded-2xl overflow-hidden select-none cursor-ew-resize bg-[#0B5D3B]"
      onMouseDown={(e) => { dragging.current = true; onMove(e.clientX); }}
      onMouseUp={() => (dragging.current = false)}
      onMouseLeave={() => (dragging.current = false)}
      onMouseMove={(e) => dragging.current && onMove(e.clientX)}
      onTouchStart={(e) => onMove(e.touches[0].clientX)}
      onTouchMove={(e) => onMove(e.touches[0].clientX)}
      data-testid="before-after-slider"
    >
      {/* Right side (after) is the full image (clean side) */}
      <img src={image} alt="After cleaning" className="absolute inset-0 w-full h-full object-cover" />
      {/* Left clip (before) */}
      <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img src={image} alt="Before cleaning" className="absolute inset-0 w-full h-full object-cover" style={{ filter: "saturate(0.6) brightness(0.85)" }} />
      </div>
      {/* Labels */}
      <div className="absolute top-4 left-4 px-3 py-1 rounded-full bg-black/70 text-white text-xs uppercase tracking-widest">Before</div>
      <div className="absolute top-4 right-4 px-3 py-1 rounded-full bg-[#D4AF37] text-black text-xs uppercase tracking-widest font-semibold">After</div>
      {/* Handle */}
      <div className="absolute top-0 bottom-0 w-0.5 bg-white" style={{ left: `${pos}%` }}>
        <div className="ba-handle absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white flex items-center justify-center">
          <div className="flex gap-0.5">
            <div className="w-1 h-4 bg-[#0B5D3B] rounded-full" />
            <div className="w-1 h-4 bg-[#0B5D3B] rounded-full" />
          </div>
        </div>
      </div>
    </div>
  );
}
